/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from '../../helpers/config';
import DownloadIcon from '../../themes/svg/downloadIcon';
import { sites } from '../../helpers/globalVariables';

class DownloadEstimateButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  getEstimatePrintUrl = () => {
    if (config.siteId === sites.blinds) {
      return `/api/myaccount/estimates/${this.props.designId}/${new Date().getTimezoneOffset()}/print`;
    }
    return `${config.designBuilderApiBaseUrl}/estimates/${this.props.designId}/${new Date().getTimezoneOffset()}/print`;
  };

  openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    if (this.props.hasProducts) {
      return (
        <div className="action downloadEstimate">
          <a
            href={this.getEstimatePrintUrl()}
            target={this.props.designId}
          >
            <DownloadIcon />
            <span id="downloadEstimateButton" className="actionText link nowrap tl">
              Download Residential
            </span>
          </a>
        </div>
      );
    }
    return null;
  }
}

DownloadEstimateButton.propTypes = {
  designId: PropTypes.string.isRequired,
  hasProducts: PropTypes.bool.isRequired,
};

export default DownloadEstimateButton;
